/* eslint id-length: 0 */
import { Experience } from "PFTypes";

import { RADIUS, RECT_BORDER_RADIUS, RECT_HT, RECT_WT } from "../../constants";
import { RatingDotsProps } from "../rating_dots/rating_dots";
import css from "./point.module.scss";

type PointProps = {
  experience: Experience;
  cx: number;
  cy: number;
} & Pick<RatingDotsProps, "color" | "shape">;

export const Point = ({ experience, cx, cy, color, shape: Shape = "circle" }: PointProps) => {
  const isCircle = Shape === "circle";

  const circPositionProps = { cx, cy, r: RADIUS };
  const rectPositionProps = {
    x: cx - RADIUS,
    y: cy - RECT_HT / 2,
    width: RECT_WT,
    height: RECT_HT,
    rx: RECT_BORDER_RADIUS
  };
  const positionProps = isCircle ? circPositionProps : rectPositionProps;

  return (
    <Shape
      className={css.circle}
      role="presentation"
      tabIndex={-1}
      data-level={experience}
      fill={color}
      {...positionProps}
    />
  );
};
